import { Platform } from 'react-native';

export function setWebPlaceholderColor(inputId, color) {
  if (Platform.OS !== 'web' || typeof document === 'undefined' || !inputId) return;
  const styleId = `vrc-search-placeholder-${inputId}`;
  let el = document.getElementById(styleId);
  if (!el) {
    el = document.createElement('style');
    el.id = styleId;
    document.head.appendChild(el);
  }
  el.textContent = `
    #${inputId}::placeholder { color: ${color} !important; opacity: 1 !important; }
    #${inputId}::-webkit-input-placeholder { color: ${color} !important; opacity: 1 !important; }
    #${inputId}::-moz-placeholder { color: ${color} !important; opacity: 1 !important; }
  `;
}

export function getAdminSearchPlaceholderColor(isDarkMode) {
  return isDarkMode ? 'rgba(255,255,255,0.55)' : 'rgba(0,0,0,0.55)';
}
